export default __webpack_public_path__ + "static/media/logo-sinfin-digital.0b155241.svg";